/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        this.flippingNumbers();
        this.matchHeights();
        this.owlCarousels();
        this.select2();
        this.misc();
        this.mobileNav();
        this.multimediaTabs();
        this.lazyLoad();
        this.stickyKit();
        this.lets_connect_form();
        this.browserCompatibility();

        function mri_int_get_random_int(min, max) {
          min = Math.ceil(min);
          max = Math.floor(max);
          return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
        }

        $(document).on('input', '#lcf_email',function(e){
          $('#mic-verify').slideDown(300);
          
        });


        jQuery('#mic-verify').each( function() {
          var verify_wrap = jQuery(this);
          verify_wrap.empty();
          var verify_html = '';
          var enc_num     = mri_int_get_random_int(1,9999);
          var key_num     = mri_int_get_random_int(1,24);
          var home_url    = verify_wrap.attr('data-hu');
          var theme_url   = verify_wrap.attr('data-td');

          verify_html += '<div class="mic-verify-w mic-left">';
          verify_html += '<input type="hidden" name="enc_num" value="'+enc_num+'">';
          verify_html += '<input type="hidden" name="key_num" value="'+key_num+'">';
          verify_html += '<a class="refresh" id="verify-refresh-captcha" href=""><img src="'+theme_url+'/dist/images/mic-refresh.png" alt="Refresh"></a>';
          verify_html += '<img id="verify_image" src="' + home_url + 'wp-json/mic/v1/cpid?enn=' + enc_num + '&ken=' + key_num + '" alt="Verification code" width="100" />';
          verify_html += '</div>';
          verify_html += '<div class="mic-verify-w mic-right">'
          verify_html += '<input type="text" name="mic_verify" id="mic_verify" class="text"  placeholder="Enter the captcha" title="This confirms you are a human user and not a bot."/>';
          verify_html += '</div>';
          verify_wrap.html(verify_html);
        });

        jQuery(document).on('click','#verify-refresh-captcha', function(e){
          e.preventDefault();
          var verify_wrap = jQuery(this).closest('#mic-verify');
          verify_wrap.empty();
          var verify_html = '';
          var enc_num     = mri_int_get_random_int(1,9999);
          var key_num     = mri_int_get_random_int(1,24);
          var home_url    = verify_wrap.attr('data-hu');
          var theme_url   = verify_wrap.attr('data-td');

          verify_html += '<div class="mic-verify-w mic-left">';
          verify_html += '<input type="hidden" name="enc_num" value="'+enc_num+'">';
          verify_html += '<input type="hidden" name="key_num" value="'+key_num+'">';
          verify_html += '<a class="refresh" id="verify-refresh-captcha" href=""><img src="'+theme_url+'/dist/images/mic-refresh.png" alt="Refresh"></a>';
          verify_html += '<img id="verify_image" src="' + home_url + 'wp-json/mic/v1/cpid?enn=' + enc_num + '&ken=' + key_num + '" alt="Verification code" width="100" />';
          verify_html += '</div>';
          verify_html += '<div class="mic-verify-w mic-right">'
          verify_html += '<input type="text" name="mic_verify" id="mic_verify" class="text"  placeholder="Enter the captcha" title="This confirms you are a human user and not a bot."/>';
          verify_html += '</div>';
          verify_wrap.html(verify_html);
        });

        // JavaScript to be fired on all pages
        function clients_logos_grid() {
          function isElementVisible($elem) {
            if (!$elem.length) return false;
            
            var docViewTop = $(window).scrollTop();
            var docViewBottom = docViewTop + $(window).height();
            var elemTop = $elem.offset().top;
            return ((elemTop <= docViewBottom - 20) && (elemTop >= docViewTop + 70));
          }

          var $gridWraps = $(document).find('.clients-logo-grid');
          
          if (!$gridWraps.length) return;
          
          $gridWraps.each(function() {
            var $gridWrap = $(this);
            var visible_items = [];
            var hidden_items = [];
            var intervalId = null;
            
            // Function to update the lists of visible and hidden items
            function update_visible_items() {
              visible_items = [];
              hidden_items = [];
              
              $gridWrap.find('.logo-wrap').each(function() {
                var $this = $(this);
                var logoId = $this.attr('data-logo');
                
                if ($this.is(':visible')) {
                  visible_items.push(logoId);
                } else {
                  hidden_items.push(logoId);
                }
              });
              
              // For debugging only - can be removed in production
              if (window.console && console.warn) {
                //console.warn('Visible items:', visible_items);
                //console.warn('Hidden items:', hidden_items);
              }
            }
            
            // Initial update
            update_visible_items();
            
            // Function to change a random logo
            function change_logo() {
              // Check if we have enough items to perform the swap
              if (visible_items.length === 0 || hidden_items.length === 0) {
                return; // Exit if we don't have enough items
              }
              
              // Select random items from visible and hidden lists
              var visible_index = Math.floor(Math.random() * visible_items.length);
              var hidden_index = Math.floor(Math.random() * hidden_items.length);
              
              var visible_replace = visible_items[visible_index];
              var hidden_replace = hidden_items[hidden_index];
              
              // Cache jQuery selections to improve performance
              var $visible_item = $gridWrap.find('.logo-wrap.logo-' + visible_replace);
              var $hidden_item = $gridWrap.find('.logo-wrap.logo-' + hidden_replace);
              
              // Check if we found valid elements
              if (!$visible_item.length || !$hidden_item.length) {
                return;
              }
              
              var $visible_content = $visible_item.find('.logo-image-cnt');
              var $hidden_content = $hidden_item.find('.logo-image-cnt');
              
              // Hide the hidden item content initially
              $hidden_content.hide();
              
              // Only proceed if we have at least one hidden item
              if (hidden_items.length >= 1) {
                // Save the original HTML before fading out
                var visible_html = $visible_content.html();
                
                $visible_content.fadeOut(1500, function() {
                  // Swap the content
                  $visible_content.empty().html($hidden_content.html());
                  
                  // Set background images for the newly visible content
                  $visible_content.find('span[data-bg]').each(function() {
                    var $span = $(this);
                    var image = $span.attr('data-bg');
                    if (image) {
                      $span.css('background-image', 'url(' + image + ')');
                    }
                  });
                  
                  // Fade in the new content
                  $visible_content.fadeIn(1500, function() {
                    // Update the hidden content after animation completes
                    $hidden_content.empty().html(visible_html);
                    
                    // Set background images for the hidden content too
                    $hidden_content.find('span[data-bg]').each(function() {
                      var $span = $(this);
                      var image = $span.attr('data-bg');
                      if (image) {
                        $span.css('background-image', 'url(' + image + ')');
                      }
                    });
                    
                    // Update the lists after the swap is complete
                    update_visible_items();
                  });
                });
              }
            }
            
            // Set up the interval for logo changes, but store the ID for cleanup
            intervalId = setInterval(function() {
              if (isElementVisible($gridWrap)) {
                change_logo();
              }
            }, 1500);
            
            // Store the interval ID on the element for potential cleanup
            $gridWrap.data('logoIntervalId', intervalId);
          });
        }

        clients_logos_grid();


        $('.section-event-form iframe').attr('height','270');
        $('.side-box.subscribe-box.subscribe-box-blog iframe.pardotform').attr('height','95');
        $(document).find('.btn.new-mri-btn').each(function(){
          var button = $(this);
          if ( button.find('span').length < 1 ) {
            var text = button.text();
            button.html( '<span>' + text + '</span>' );
          }
        });

        $(document).on('click','.new-mega-menu-navigation > ul > li.dropdown-menu > a',function(e){
          e.preventDefault();
          var list_item = $(this).closest('li.dropdown-menu');
          $(this).closest('ul').find('li.dropdown-menu').each(function(){
            if ( $(this)[0] !== list_item[0] ) {
              $(this).removeClass('menu-open');
            }
          });

          list_item.toggleClass('menu-open');
          if ( list_item.is('.menu-open') ) {
            $('body').addClass('rm-has-menu-open');
          } else {
            $('body').removeClass('rm-has-menu-open');
          }
        });

        $(document).on('click','.mr-mmov', function(){
          $('.new-mega-menu-navigation .menu-open').removeClass('menu-open');
          $('body').removeClass('rm-has-menu-open');
        });

        (function ($) {
          var methods = ['addClass', 'toggleClass', 'removeClass'];

          $.each(methods, function (index, method) {
            var originalMethod = $.fn[method];

            $.fn[method] = function () {
              if ( this[0] ) {
                var oldClass = this[0].className;
                var result = originalMethod.apply(this, arguments);
                var newClass = this[0].className;

                this.trigger(method, [oldClass, newClass]);

                return result;
              }
            };
          });
        }(window.jQuery || window.Zepto));



        $('body').on('addClass toggleClass removeClass', function (e, oldClass, newClass) {

          // if ( ! $('body').hasClass('gdpr-infobar-visible') ) {
            $('header#main-header').removeAttr('style');
            $('.site-content').removeAttr('style');    
            $('#mri-mobile-menu-container').removeAttr('style');   
          // } else {
          //   if( window.innerWidth < 768 ) {
          //     $('header#main-header').css('top',$('#moove_gdpr_cookie_info_bar').height());
          //     $('.site-content').css('padding-top',$('#moove_gdpr_cookie_info_bar').height() + 70);
          //     $('#mri-mobile-menu-container').css('padding-top',$('#moove_gdpr_cookie_info_bar').height() + 70);
          //   }
          // }
        });       

        $(document).on('click','.btn-inlinescroll',function(e){
          e.preventDefault();
          var id = $(this).attr('href');
          if ( $(id).length > 0 ) {
            $('body,html').animate({
                scrollTop: $(id).offset().top - 100
            }, 300);
          }

        });

        if( $('body').hasClass('page-template-team-list') ) {
          
          var active_item = $('.grid_accordion').attr('data-active');
          if(active_item && active_item != '') {
            setTimeout(function(){ $('.grid_accordion .grid_accordion_block--trigger[data-slug='+active_item+']').click(); }, 1000);
          }
        }

        $('.offices-map .map-cont .city').click( function(e){
          e.preventDefault();
          $(this).closest('.city-cont').find('.location-modal').fadeIn().css("display","inline-block");
        })

        $('.offices-map .map-cont .location-modal-close, .offices-map .map-cont .location-modal-overlay').click(function(e){
          e.preventDefault();
          $('.offices-map .map-cont .location-modal').fadeOut();
        });

        $('.offices-map .mobile-modal-cont .mobile-modal-item .mobile-modal-item-header').click( function(e) {
          e.preventDefault();
          var is_active = $(this).closest('.mobile-modal-item').hasClass('active');
          $('.offices-map .mobile-modal-cont .mobile-modal-item').removeClass('active');
          $('.offices-map .mobile-modal-cont .mobile-modal-item .mobile-modal-item-body').hide();

          if( !is_active ) {
            $(this).closest('.mobile-modal-item').addClass('active');
            $(this).closest('.mobile-modal-item').find('.mobile-modal-item-body').fadeIn();
          } 

        })

        window.addEventListener('touchstart', function onFirstTouch() {
          $('body').addClass('touch-device');
          $('.btn.new-mri-btn').each(function(){
              var span = $(this).find('span');
              if(span.length > 0){
                  $(this).html( span.html() );
              }
          })
          window.removeEventListener('touchstart', onFirstTouch, false);
        }, false);

        /*
         Open Social Share in new window on click
         */
        $(document).on('click', '.social-share a.popup', function (e) {
            if ( ! $(this).closest('div').is('.media-center') ) {
                e.preventDefault();
                var w = 500, h = 400, left = Number((screen.width / 2) - (w / 2)), top = Number((screen.height / 2) - (h / 2));
                window.open($(this).prop('href'), '', "width=" + w + ", height=" + h + ", top=" + top + ", left=" + left + "");
            }
        });        

      },
      browserCompatibility: function() {

        function getBrowserVersion() {
          var result = {};
          var ua= navigator.userAgent, tem, 
          M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
          if(/trident/i.test(M[1])){
              tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
              return 'IE '+(tem[1] || '');
          }
          if(M[1] === 'Chrome'){
              tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
              if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
          }
          M = M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
          if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
          result.app = M[0];
          result.ver     = M[1];
          return result;
        };

        //CSS justify-content for Chrome < v56 & Safari < v11
        var browser = getBrowserVersion();
        if( (browser.app === 'Chrome' && parseInt(browser.ver) < 56) || (browser.app === 'Safari' && parseInt(browser.ver) < 11) ) {
          $('body').addClass('no-justify-content');
        }

      },
      stickyKit: function() {
        $('.flex-section-container .social-share').stick_in_parent({
          // offset_top: 95,
        });
      },
      lets_connect_form: function() {
        function isScrolledIntoView($elem) {
          var returnvalue = false;
          if ( $elem.length > 0 ) {
            var docViewTop = $(window).scrollTop();
            var docViewBottom = docViewTop + $(window).height();
            var elemTop = $elem.offset().top;
            returnvalue = ((elemTop <= docViewBottom - 20) && (elemTop >= docViewTop + 20));
          }
          return returnvalue;
        }

        var country_select_init = false;

        if ( $('.lets-connect-form').length > 0 ) {

          var utm_query_string = window.location.search;
          if ( utm_query_string ) {
            try {
              var utm_url_params  = new URLSearchParams(utm_query_string);
              var utm_source      = utm_url_params.get('utm_source');
              var utm_medium      = utm_url_params.get('utm_medium');
              var utm_campaign    = utm_url_params.get('utm_campaign');

              var utm_term        = utm_url_params.get('utm_term');
              var utm_content     = utm_url_params.get('utm_content');

              if ( utm_source ) {
                $('input[name=lcf_utm_source]').val(utm_source);
              }

              if ( utm_medium ) {
                $('input[name=lcf_utm_medium]').val(utm_medium);
              }

              if ( utm_term ) {
                $('input[name=lcf_utm_term]').val(utm_term);
              }

              if ( utm_content ) {
                $('input[name=lcf_utm_content]').val(utm_content);
              }

              if ( utm_campaign ) {
                $('input[name=lcf_utm_campaign]').val(utm_campaign);
                $('input[name=lcf_utm_campign]').val(utm_campaign);
              }
            } catch(err) {
              console.warn(err);
            }
          }

          function init_countries() {
            $(".lets-connect-form select option:empty").remove();

            $('.lcf_select2').select2({minimumResultsForSearch: -1});

            var countries = $.fn.countrySelect.getCountryData();

            var county_select = $('.lcf_country').select2({minimumResultsForSearch: -1});

            var blog_id = $('#lcf_country').attr('data-bid');

            var current_country = 'us';
            switch( blog_id ) {
              case '1':
                current_country = 'us';
                break;
              case '2':
                current_country = 'gb';
                break;
              case '3':
                current_country = 'ca';
                break;
              case '4':
                current_country = 'au';
                break;
              case '5':
                current_country = 'nz';
                break;
              case '6':
                current_country = 'sg';
                break;
              case '7':
                current_country = 'hk';
                break;
              case '8':
                current_country = 'ae';
                break;
              case '9':
                current_country = 'za';
                break;
              case '10':
                current_country = 'ie';
                break;
              default:
                current_country = 'us';
            }

            $(countries).each(function(i,v){
              var c_name = v.name; 
              c_name = c_name.replace(/\(.*\)/g,'').trim();
              
              county_select.append( $('<option>', {value: c_name, text: c_name} ) );
              if ( v.iso2 === current_country ) {
                county_select.val( v.name );
              }
            });

            country_select_init = true;
          }

          if ( isScrolledIntoView( $("#lcf_country") ) && ! country_select_init ) {
            init_countries();
          }

          $(window).scroll(function() {
            if ( isScrolledIntoView( $("#lcf_country") ) && ! country_select_init ) {
              init_countries();
            }
          });

          var form_validator = $('#lets-connect .mri-pardot-form').validate({
            onkeyup: false,
            errorClass : 'has-error', 
            rules: {
              'lcf_first_name' : 'required',
              'lcf_last_name'  : 'required',
              'lcf_company'  : 'required',
              'lcf_email'      : {
                  required: true,
                  email: true
              },
              'lcf_postcode'   : 'required',
              'lcf_properies_managed'    : 'required',
              'lcf_metro_interested_in'    : 'required',
              'lcf_job_category'    : 'required',
              'lcf_apartment_data_role' : 'required',
              'lcf_requirements'    : 'required',
              'mic_verify': 'required',
            },
            messages: {
              'lcf_first_name'  : 'Please enter your first name',
              'lcf_last_name'   : 'Please enter your last name',
              'lcf_company'     : 'Please enter your company',
              'lcf_email'       : {
                  required  : 'Please enter your email',
                  email     : 'Please enter valid email address'
              },
              'lcf_postcode'    : 'Please enter your postcode',
              'lcf_properies_managed'    : 'This field is required',
              'lcf_metro_interested_in'    : 'Please select',
              'lcf_job_category'    : 'Please select',
              'lcf_apartment_data_role'    : 'Please select',
              'lcf_requirements'    : 'This field is required',
              'mic_verify'    : 'This field is required',
            },
            errorPlacement: function(error, element) {
              error.appendTo(element.closest('.form-group'));
              $('#mic-verify').slideDown(300);
            },
            highlight: function(element, errorClass, validClass) {
              $(element).closest('.form-group').addClass(errorClass).removeClass(validClass);
              $('#mic-verify').slideDown(300);
            },
            unhighlight: function(element, errorClass, validClass) {
              $(element).closest('.form-group').removeClass(errorClass).addClass(validClass);
            },
            submitHandler: function(e) {
              var formdata  = $('#lets-connect .mri-pardot-form').serialize();
              var button = $('#lets-connect button[type="submit"]');              
              button.button('loading');
              $.post(
                mri_moove_scripts.ajaxurl,
                {
                    action: "send_pardot_connect_form",
                    formdata: formdata,
                },
                function(data) {
                  data = JSON.parse( data );
                  
                  if( data.success === true ) {
                    console.log('Request sent to pardot!');
                    if ( typeof data.redirect !== undefined && data.redirect ) {
                      window.location.href = data.redirect;
                    }
                  } else {
                    console.log('Failed to send Pardot data. Err:'+ data.response);
                    button.button('reset');

                    if ( data.response === 'Check the captcha field' ) {
                      $('#mic_verify').val('');
                      if ( $('#mic_verify-error').length > 0 ) {
                        $('#mic_verify-error').text('Captcha verification failed, try again!').show();
                      } else {
                        $('#mic-verify').closest('.form-group').find('#mic_verify-error').remove();
                        $('#mic-verify').closest('.form-group').append('<label id="mic_verify-error" class="has-error" for="mic_verify">Captcha verification failed, try again!</label>')
                      }
                      
                    }
                  }

                }
              );

              return false;

            }
          });
        }

        $(document).on('click','a[href*="#request_demo"]',function(e){
          if ( $('#lets-connect').length > 0 ) {
            e.preventDefault();
            $('#lcf_request_type_info').prop('checked',false);
            $('#lcf_request_type_demo').prop('checked',true);

            $('body,html').animate({
              scrollTop: $('#lcf_contact_form_wrap').offset().top - 100
            }, 300);
          }
        });

        $(document).on('click','a[href*="#request_info"], a[href*="#request_information"]',function(e){
          if ( $('#lets-connect').length > 0 ) {
            e.preventDefault();
            $('#lcf_request_type_info').prop('checked',true);
            $('#lcf_request_type_demo').prop('checked',false);

            $('body,html').animate({
              scrollTop: $('#lcf_contact_form_wrap').offset().top - 100
            }, 300);
          }
        });
      },
      owlCarousels: function() {
        $('.featured-customers .owl-carousel').owlCarousel({
          center: false,
          items: 1,
          loop: true,
          nav: false,
          dots: false,
          margin: 40,
          drag: true,
          navText: ['',''],
          responsive : {
            0 : {
              items: 1,
              margin: 20,
              stagePadding: 80,
              dots: true,
              nav: true,
            },
            768 : {
              items: 1,
              stagePadding: 200,
              dots: true,
              nav: true,
            },
            1010 : {
              items: 5,
              stagePadding: 0,
              dots: false,
              nav: false,
              drag: false,
              mouseDrag: false,
              touchDrag: false,
              pullDrag: false,
              freeDrag: false,
            }
          }
        });

        $('section.flipping-numbers .owl-carousel').each(function(){
          var count = 5;
          var tcount = 3;
          var items = $(this).find('.number-box-item');
          if ( items.length < 5 ) {
            count = items.length;
          }
          if ( items.length < 3 ) {
            tcount = items.length;
          }
          $(this).owlCarousel({
            center: false,
            items: 1,
            loop: false,
            nav: true,
            dots: false,
            margin: 30,
            drag: true,
            navText: ['',''],
            autoheight: true,
            startPosition: 0,
            responsive : {
              0 : {
                items: 1,
                dots: false,
                nav: true,
                loop: false,
                center: true
              },
              768 : {
                items: tcount,
                stagePadding: 0,
                center: false,
                loop: false,
                dots: false,
              },
              1010 : {
                items: count,
                stagePadding: 0,
                dots: false,
                nav: false,
                drag: false,
                mouseDrag: false,
                touchDrag: false,
                pullDrag: false,
                freeDrag: false,
              }
            }
          });

        });

        $('section.home-hero-slider .owl-carousel').owlCarousel({
          center: true,
          items: 1,
          loop: true,
          nav: true,
          navContainer: 'section.home-hero-slider .owl-nav-container .container',
          navText: ['<i class="fa fa-chevron-left" aria-hidden="true"></i>','<i class="fa fa-chevron-right" aria-hidden="true"></i>'],
          dots: true,
          dotsContainer: 'section.home-hero-slider .owl-nav-container .container .owl-dots',
          margin: 0,
          drag: true,
          autoHeight: true,
          startPosition: 0
        });

        var client_slider = $('section.clients-slider .owl-carousel').each(function(){
          var class_id = '_' + Math.random().toString(36).substr(2, 9);
          $(this).closest('section').find('.owl-nav-container').addClass('owl'+class_id);
          $(this).owlCarousel({
            center: false,
            items: 1,
            loop: false,
            nav: false,
            smartSpeed: 500,
            dots: false,
            dotsContainer: '.owl' + class_id + ' .owl-dots',
            margin: 0,
            drag: true,
            navContainer: '.owl' + class_id + ' .owl-nav',
            navText: ['<i class="fa fa-chevron-left" aria-hidden="true"></i>','<i class="fa fa-chevron-right" aria-hidden="true"></i>'],
            autoheight: true,
            responsive : {
              0 : {
                items: 1,
                stagePadding: 50,
                dots:true
              },
              768 : {
                items: 3,
                stagePadding: 50,
                dots:true
              },
              1010 : {
                items: 5
              }
            }
          });
          $(this).on('click', '.owl-item', function() {
            if( window.outerWidth < 1010) {
              client_slider.trigger('to.owl.carousel', parseInt(  [$(this).find( '.client-box' ).attr('data-index'), 1, true] ) ) ;
            }
          });
        });


        var sync1 = $('section.full-image-slider .full-image-slider-body.owl-carousel');
        var sync2 = $('section.full-image-slider .full-image-slider-nav.owl-carousel');
        var slidesPerPage = 6; //globaly define number of elements per page
        var syncedSecondary = true;

        var class_id = '_' + Math.random().toString(36).substr(2, 9);
        sync1.closest('section').find('.owl-nav-container').addClass('owl'+class_id);
        sync1.owlCarousel({
            center: false,
            items: 1,
            loop: true,
            nav: true,
            dots: true,
            dotsData : true,
            dotsContainer: '.owl' + class_id + ' .owl-dots',
            margin: 0,
            drag: true,
            navContainer: '.owl' + class_id + ' .owl-nav',
            navText: ['<i class="fa fa-chevron-left" aria-hidden="true"></i>','<i class="fa fa-chevron-right" aria-hidden="true"></i>'],
            autoHeight: true,
        }).on('changed.owl.carousel', function(e) {
          syncPosition(e);
          var current = e.relatedTarget.current();
          var bg_img = $(e.target).find(".owl-item").eq(current).find(".full-image-slider-item").attr("data-bg-img");
          $('.full-image-slider-cont').css('background-image', 'url('+bg_img+')' );
          // console.log( $(el).find('.owl-item.active .full-image-slider-item').attr('data-bg-img') );
        });

        sync2.on('initialized.owl.carousel', function () {
          sync2.find(".owl-item").eq(0).addClass("current");
        }).owlCarousel({
            items : slidesPerPage,
            dots: false,
            nav: false,
            slideBy: slidesPerPage,
            margin: 30,
            responsive:{
              0:{
                  items:1,
                  nav:false
              },
              600:{
                  items: 3
              },
              1000:{
                  items: slidesPerPage
              }
            }
        }).on('changed.owl.carousel', syncPosition2);

        function syncPosition(el) {
          //if you set loop to false, you have to restore this next line
          //var current = el.item.index;
          
          //if you disable loop you have to comment this block
          var count = el.item.count-1;
          var current = Math.round(el.item.index - (el.item.count/2) - .5);
          
          if(current < 0) {
            current = count;
          }
          if(current > count) {
            current = 0;
          }
          
          //end block

          sync2
            .find(".owl-item")
            .removeClass("current")
            .eq(current)
            .addClass("current");
          var onscreen = sync2.find('.owl-item.active').length - 1;
          var start = sync2.find('.owl-item.active').first().index();
          var end = sync2.find('.owl-item').last().index();
          
          if (current > end) {
            sync2.data('owl.carousel').to(current, 100, true);
          }
          if (current < start) {
            sync2.data('owl.carousel').to(current - onscreen, 100, true);
          }
        }
  
        function syncPosition2(el) {
          if(syncedSecondary) {
            var number = el.item.index;
            sync1.data('owl.carousel').to(number, 100, true);
          }
        }
        
        sync2.on("click", ".owl-item", function(e){
          e.preventDefault();
          var number = $(this).index();
          sync1.data('owl.carousel').to(number, 300, true);
        });

      },
      multimediaTabs:function() {
        function iOS() {
          var iDevices = [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
          ];

          if (!!navigator.platform) {
            while (iDevices.length) {
              if (navigator.platform === iDevices.pop()){ return true; }
            }
          }

          return false;
        }
        $(function(){var b="fadeInLeft";var c;var a;function d(e,f,g){e.click(function(i){i.preventDefault();$(this).tab("show");var h=$(this).data("easein");if(c){c.removeClass(a);}if(h){f.find("div.active").addClass("animated "+h);a=h;}else{if(g){f.find("div.active").addClass("animated "+g);a=g;}else{f.find("div.active").addClass("animated "+b);a=b;}}c=f.find("div.active");});}$("a[rel=popover]").popover().click(function(f){f.preventDefault();if($(this).data("easein")!==undefined){$(this).next().removeClass($(this).data("easein")).addClass("animated "+$(this).data("easein"));}else{$(this).next().addClass("animated "+b);}});d($(".multimedia-navs a"),$(".multimedia-box .tab-content"));});
        function detectmob() {
           if(window.innerWidth <= 800 && window.innerHeight <= 600) {
             return true;
           } else {
             return false;
           }
        }
        $('.multimedia-navs a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
          var target = $(e.target).attr("href"); // activated tab

          $(this).closest('.multimedia-box').find('.section-background-content .tab-bg-hld').fadeOut(400);
          $(this).closest('.multimedia-box').find('.section-background-content video').each(function(){
            if ( ! $(this)[0].paused && ! iOS() && ! detectmob() ) {
              $(this)[0].pause();
            }
          });
          $(this).closest('.multimedia-box').find('.section-background-content .tab-bg-hld[data-tab="'+target+'"]').fadeIn(400);
          var video = $(this).closest('.multimedia-box').find('.section-background-content .tab-bg-hld[data-tab="'+target+'"]').find('video');
          if ( ( video.length > 0 ) && ! iOS() && ! detectmob() ) {
            if ( video[0].paused ) {
              video[0].play();
            }
          }
        });
        $('.multimedia-navs a[data-toggle="pill"]').each(function(e){
          if ( $(this).closest('li').hasClass('active') ) {
            var target = $(this).attr("href"); // activated tab

            $(this).closest('.multimedia-box').find('.section-background-content .tab-bg-hld').fadeOut(400);
            $(this).closest('.multimedia-box').find('.section-background-content video').each(function(){
              if ( ! $(this)[0].paused && ! iOS() && ! detectmob() ) {
                $(this)[0].pause();
              }
            });
            $(this).closest('.multimedia-box').find('.section-background-content .tab-bg-hld[data-tab="'+target+'"]').fadeIn(400);
            var video = $(this).closest('.multimedia-box').find('.section-background-content .tab-bg-hld[data-tab="'+target+'"]').find('video');
            if ( ( video.length > 0 ) && ! iOS() && ! detectmob() ) {
              if ( video[0].paused ) {
                video[0].play();
              }
            }
          }
        });
      },
      mobileNav: function(){
        $(document).on('click','#mobile-menu-trigger',function(e){
          e.preventDefault();
          $(this).toggleClass('menu-open');
          $('body').toggleClass('mobile-menu-open');
        });
        function isElementVisible($elem) {

          var docViewTop = $(window).scrollTop();
          var docViewBottom = docViewTop + $(window).height();
          var elemTop = $elem.offset().top;
          var returnvalue = ((elemTop <= docViewBottom - 20) && (elemTop >= docViewTop + 70));
          return returnvalue;

        }
        $(document).on('click','#mri-mobile-menu-container li.menu-item-has-children > a',function(e){
          e.preventDefault();
          var menu_parent = $(this).closest('li');
          menu_parent.closest('ul').find('li.menu-open').each(function(){
            if ( $(this)[0] !== menu_parent[0] ) {
              $(this).removeClass('menu-open');
            }
          });
          menu_parent.toggleClass('menu-open');
          if ( menu_parent.hasClass('menu-open') ) {
            if ( ! isElementVisible( menu_parent ) ) {
              menu_parent.get(0).scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
        });
        $(document).on('change','.mobile-region-select-cnt select',function(e){
          e.preventDefault();
          var url = $(this).val();
          if ( url ) {
            window.location.href = url;
          }
        });
      },
      matchHeights: function() {
        $('.menu-item-products .products-matchheight').matchHeight();
        $('section.solution-boxes .box-content h6').matchHeight();
        $('section.solution-boxes .box-content .box-main-cnt').matchHeight();
        $('section.solution-boxes').matchHeight();
        $('.flex--multiple_columns .grid__item').matchHeight();

        $('section.contact-locations .location-box').matchHeight();
        $('section.cards-without-icon .card-content').matchHeight();
        
        $('.mri-article-card').matchHeight();
        $('.new-mega-menu-navigation .dropdown-menu.menu-item-products').each(function(){
          $(this).find('.dropdown-submenu > li').matchHeight();
        });

        $('.section.flipping-numbers.numbers-separated-vr .mri-flipping-animate-item').matchHeight();

        $('section.quick-links .flexible-box .box-label').matchHeight();
        $('section.quick-links .flexible-box .box-title').matchHeight();
        $('section.quick-links .flexible-box').matchHeight();

        $('section.features .feature-box .box-title').matchHeight();
        $('section.features .feature-box .box-content').matchHeight();
        $('section.features .feature-box').matchHeight();

        $('section.features .feature-box').matchHeight();

        $('section.section-resource-list .resource-list-cont article').matchHeight();
        $('section.section-resource-list .resource-list-cont .article-details').matchHeight();

        $('.card_equal_heights .team-member-info').matchHeight({byRow: true});

        $('.post-list-cont article .card-blog-mh').matchHeight({byRow: true});

        $('.new-mega-menu-navigation .dropdown-menu.menu-item-solution').each(function(){
          $(this).find('.dropdown-submenu > li.submenu-groups').matchHeight({byRow: true});
          $(this).find('.dropdown-submenu > li.submenu-groups .submenu-group-title').matchHeight();

          $('section.job-opportunities .job-body .job-meta').matchHeight();
          $('section.job-opportunities .job-body .job-title').matchHeight();
        });
        $('.new-mega-menu-navigation li.dropdown-menu.menu-item-solution-has-related').hover(function() {
          $(this).find('.dropdown-submenu > li.submenu-groups').matchHeight({byRow: true});
          $(this).find('.dropdown-submenu > li.submenu-groups .submenu-group-title').matchHeight({byRow: true});
          console.log('mh');
        });


        $('.top-navigation .menu-item-has-children.tiled-submenu-item ul.sub-menu li').matchHeight( {byRow: false } );

        $('.row-centered .col-centered').matchHeight();

        setTimeout(function(){
          $('.row-centered .col-centered').matchHeight();
        }, 1000);

        if ($(window).width() >= 768) {
          $('section.contact-boxes .box-mh').matchHeight( {byRow: false });
        }

        const observer = lozad('*[data-background-image], .lozad-picture, *[data-src]', {
          rootMargin: '10px 0px', // syntax similar to that of CSS Margin
          threshold: 0.1,
          loaded: function(el) {
            // Custom implementation on a loaded element
            el.classList.add('loaded');

          }
        });
        observer.observe();

      },
      flippingNumbers: function() {
        // FLIPPING NUMBERS
        function isInt(n) {
          return Number(n) === n && n % 1 === 0;
        }

        function isFloat(n) {
          return Number(n) === n && n % 1 !== 0;
        }

        function isScrolledIntoView($elem) {

          var docViewTop = $(window).scrollTop();
          var docViewBottom = docViewTop + $(window).height();
          var elemTop = $elem.offset().top;
          var returnvalue = ((elemTop <= docViewBottom - 20) && (elemTop >= docViewTop + 20));
          return returnvalue;

        }

        function mri_animate_numbers($elem) {
          if (!$elem) {
            $('.mri-flipping-animate-numbers').each(function () {
              if (isScrolledIntoView($(this))) {
                if (!$(this).hasClass('animated')) {
                  $(this).addClass('animated');
                  var duration = $(this).attr('data-duration');
                  $(this).find('.mri-flipping-animate-item').each(function () {
                    $(this).css('width',$(this).width());
                    var options = {
                      useEasing: false,
                      useGrouping: true,
                      separator: '',
                      decimal: '',
                      prefix: '',
                      suffix: ''
                    };
                    var suffix = $(this).attr('data-suffix'),
                      prefix = $(this).attr('data-prefix'),
                      number = $(this).attr('data-number'),
                      grouping = $(this).attr('data-grouping'),
                      separator = $(this).attr('data-separator'),
                      decimals = 0,
                      decimal = $(this).attr('data-decimal');
                    if (number.indexOf('.') !== -1) {
                      decimals = 1;
                    }
                    if (grouping === "true") {
                      options.useGrouping = true;
                      options.decimal = decimal;
                      options.separator = separator;
                    } else {
                      options.useGrouping = false;
                    }
                    if (prefix !== "false") {
                      options.prefix = prefix;
                    }
                    if (suffix !== "false") {
                      options.suffix = suffix;
                    }
                    var countup = new CountUp($(this).find('.mri-flipping-number-cnt')[0], 0, number, decimals, duration, options);
                    countup.start();
                  });
                }
              }
            });
          } else {
            if (isScrolledIntoView($elem)) {
              var duration = $elem.attr('data-duration');
              $elem.find('.mri-flipping-animate-numbers').addClass('animated');
              $elem.find('.mri-flipping-animate-item').each(function () {
                $(this).css('width',$(this).width());
                var options = {
                    useEasing: false,
                    useGrouping: true,
                    separator: '',
                    decimal: '',
                    prefix: '',
                    suffix: ''
                };
                var suffix = $(this).attr('data-suffix'),
                    prefix = $(this).attr('data-prefix'),
                    number = $(this).attr('data-number'),
                    grouping = $(this).attr('data-grouping'),
                    separator = $(this).attr('data-separator'),
                    decimals = 0,
                    decimal = $(this).attr('data-decimal');
                if (number.indexOf('.') !== -1) {
                    decimals = 1;
                }
                if (grouping === "true") {
                    options.useGrouping = true;
                    options.decimal = decimal;
                    options.separator = separator;
                } else {
                    options.useGrouping = false;
                }
                if (prefix !== "false") {
                    options.prefix = prefix;
                }
                if (suffix !== "false") {
                    options.suffix = suffix;
                }
                var countup = new CountUp($(this).find('.mri-flipping-number-cnt')[0], 0, number, decimals, duration, options);
                countup.start();
              });
            }
          }
        }

        mri_animate_numbers();

        $(window).scroll(function () {
          mri_animate_numbers();
        });
      },
      select2: function(){

        if(window.innerWidth >= 768){

          $('.page-template-partners-list .post_filter_filter .select--filter').select2();

          $('.filter-section .filter-cont select').select2();

          $('.filter-section .filter-cont .filter-open').click(function(){
            $(this).closest('.filter-group').find('select').data('select2').toggleDropdown();
          });

        } else {
            
          // $('.filter-section .filter-cont .filter-open').click(function(){
          //   $('.filter-section .filter-cont select').trigger('click');
          // });
        }

      },
      lazyLoad: function() {

          var ajaxurl = mri_moove_scripts.ajaxurl ;
          var doc = $(document), w = $(window), timer;
          var preloader      = $('.ajax-preloader');
          var post_type      = 'post';
          var current_page   = 1;
          var action         = null;
          var list_cont      = $('.lazy-load-cont');
          var auto_load      = false;
          var tax            = null;
          var term           = null;
          var filter         = [];
          var search         = null;
          var post_per_page  = null;
          var exclude        = [];
          var permalink      = mri_moove_scripts.permalink; 
          var featured_posts = [];
          var featured_res   = [];
          var page_id        = $('body').attr('data-postid');

          function autoLoad() {

            doc.on('scroll', function () {
              var footer_top  = $('footer.site-footer').offset().top;
              var list_bottom = list_cont.offset().top + list_cont.outerHeight();
              
              if (doc.scrollTop() + w.height() >= list_bottom && auto_load ) {

                if (typeof timer !== 'undefined') {
                  clearTimeout(timer);
                }

                if ( !$('body').hasClass('ajax-loading') && list_cont.attr('data-max-pages') > 1 && current_page < list_cont.attr('data-max-pages') ) {

                  preloader.fadeIn();
                  timer = setTimeout(function () {
                    current_page++;

                    loadList();

                  }, 500);

                } 

              }
            });
          }

          function afterAutoload() {

            if ( $('body').hasClass('page-template-events-list') ) {
              $(document).find('.mri-no-results-label').addClass('hide');
              $('body').addClass('ajax-loading');
              $.get(ajaxurl, {
                action: 'load_online_event_list',
                post_type: post_type,
                page: current_page,
                search: search,
                filter: filter,
                post_per_page: post_per_page,
                exclude: exclude
              }, function (data) {

                online_events_loaded = true;

                $('body').removeClass('ajax-loading');

                if ( data.items.length <= 0 ) {
                  $(document).find('.mri-no-results-label').removeClass('hide');
                }

                $.each(data.items, function(i, v) {
                  list_cont.append(v);
                });
                preloader.fadeOut();

                const observer = lozad('*[data-background-image], .lozad-picture, *[data-src]', {
                  rootMargin: '10px 0px', // syntax similar to that of CSS Margin
                  threshold: 0.1,
                  loaded: function(el) {
                    // Custom implementation on a loaded element
                    el.classList.add('loaded');

                  }
                });
                observer.observe();

              }, 'JSON');
            }

          }

          function loadList() {
              $('body').addClass('ajax-loading');
              var url = permalink;
              $.get(ajaxurl, {
                action: action,
                post_type: post_type,
                page: current_page,
                search: search,
                filter: filter,
                featured_res: featured_res,
                page_id: page_id,
                post_per_page: post_per_page,
                exclude: exclude
              }, function (data) {
                $('body').removeClass('ajax-loading');

                if( filter.length > 0 )  {
                  if( !$('.featured-list-cont').hasClass('hide') ) {
                    $('.featured-list-cont').addClass('hide');
                  }
                } else {
                  $('.featured-list-cont').removeClass('hide');
                }

                list_cont.attr('data-max-pages', data.max_pages );                
                if(data.items.length > 0) {
                  $.each(data.items, function(i, v) {
                    list_cont.append(v);
                  });
                  auto_load = true;
                } else {
                  list_cont.append('<h3 class="mri-no-results-label">Sorry, no results were found.</h3>');
                  auto_load = false;
                }

               

                $.each( filter, function(i,v) {
                  if( v.tax == 'resource_type' ) {
                    url = permalink + 'type/' + v.term;                      
                    history.pushState(null, null, url );
                  }
                });

                if( data.last_page === true ) {
                  afterAutoload();
                } else {
                  $(document).find('.mri-no-results-label').removeClass('hide');
                }
                
                Sage.common.matchHeights();

                preloader.fadeOut();

              }, 'JSON');
          }

          function loadPopularList( post_type, post_id, sector ) {

              var popular_list_cont = $('.side-box.most-popular-box .most-popular-list-cont');

              $.get(ajaxurl, {
                action: 'load_popular_list',
                post_type: post_type,
                sector: sector,
                exclude: post_id
              }, function (data) {

                popular_list_cont.empty();

                $.each(data.items, function(i, v) {
                  popular_list_cont.append(v);
                });

                if(sector && data.items.length == 0 ) {
                  loadPopularList( post_type, post_id, null );
                }

                const observer = lozad('*[data-background-image], .lozad-picture, *[data-src]', {
                  rootMargin: '10px 0px', // syntax similar to that of CSS Margin
                  threshold: 0.1,
                  loaded: function(el) {
                    // Custom implementation on a loaded element
                    el.classList.add('loaded');

                  }
                });
                observer.observe();

              }, 'JSON');
          }

          if( typeof list_cont.attr('data-exclude') !== typeof undefined && list_cont.attr('data-exclude') !== false ) {
            exclude = list_cont.attr('data-exclude').split(',');
          }

          $('.filter-form').submit( function() {
            var form = $(this);
            current_page = 1;
            online_events_loaded = false;
            search = form.find('#search-list').val();
            filter = [];


            $(form.find('.filter-field')).each( function() {
              var term = $(this).val();
              if( term !== 'all' && term !== '' ) {
                var fltr = {};
                fltr.tax = $(this).attr('data-tax');
                fltr.term = $(this).val();
                filter.push(fltr);
              } 
            });

            if ( !$('body').hasClass('ajax-loading') ) {
              list_cont.empty();
              preloader.fadeIn();
              timer = setTimeout(function () {
                loadList();
              }, 500);
            }

            form[0].reset();
            
            return false;
          });

          $('.filter-form select.filter-field').each( function() {

            var term = $(this).val();
            if( term !== 'all' && term !== '' ) {
              var fltr = {};
              fltr.tax = $(this).attr('data-tax');
              fltr.term = $(this).val();
              filter.push(fltr);
            } 

          })

          $('.filter-form select.filter-field').change( function() {
            $(this).closest('form').submit();
            $('.featured-list-cont').addClass('hide');

            if ( $('body').hasClass('page-template-news-list') || $('body').hasClass('page-template-blog-list') ) {
              if( $(this).is('#sector-filter') ) {
                var popular_sector = null;
                if( $(this).val() !== 'all' ) {
                  popular_sector = $(this).val();
                }
                loadPopularList( post_type, null, popular_sector );
              }
            }
            if ( $('body').hasClass('page-template-resources-list') ) {
              if( $(this).is('#type-filter') ) {                
                if( $(this).val() == 'all' ) {
                  history.pushState(null, null, permalink );
                }                
              }
            } 

          });

          if ( $('body').hasClass('page-template-news-list') ) {
            auto_load = true;
            post_type = 'news';
            action = 'load_post_list';

          }

          if ( $('body').hasClass('page-template-blog-list') ) {
            auto_load = true;
            post_type = 'post';
            action = 'load_post_list';
          }

          if ( $('body').hasClass('page-template-resources-list') ) {
            auto_load = true;
            post_type = 'resources';
            post_per_page = 8;
            action = 'load_resources_list';
            featured_res = list_cont.attr('data-featured');
            featured_res = JSON.parse( featured_res );
          }

          if ( $('body').hasClass('page-template-events-list') ) {
            auto_load = true;
            post_type = 'event';
            post_per_page = 6;
            action = 'load_event_list';
          }

          if( auto_load ) {
            autoLoad();
          }


      },
      misc: function() {
        window.addEventListener('iframe_message', function(e) {
          var url = e.detail.url;
          console.log(url);
          if ( url ) {
            window.top.location.href = url;
          }
        }, false);

        jQuery('.scrollbar-outer').scrollbar();
        

        $(window).load(function() {
          // Animate loader off screen
          $('section.page-header-hero .content-image-cnt .animated-content-image img').addClass('tilt');
        });
        
        $(document).on('click','#header_search_trigger',function() {
            $('#main-header .header__search').toggleClass( "focused" );
        });

        $('.card_equal_heights .grid_accordion_block--trigger ').matchHeight({byRow: true});

        // Sticky nav
        window.onscroll = function() {
          if ( $(window).scrollTop() > 200 ) {
            $('#main-header').addClass( 'header-affix' );
          } else {
            $('#main-header').removeClass( 'header-affix' );
          }
        };

        function isElementVisible($elem) {

          var docViewTop = $(window).scrollTop();
          var docViewBottom = docViewTop + $(window).height();
          var elemTop = $elem.offset().top;
          var returnvalue = ((elemTop <= docViewBottom - 20) && (elemTop >= docViewTop + 70));
          return returnvalue;

        }

        // MRI TABS
        $(document).on('click','.mri-tab-section button.tablinks',function(e){
          e.preventDefault();
          var parent = $(this).closest('.mri-tab-section');
          if ( ! $(this).hasClass('active') ) {
            var tab_id = $(this).attr('data-tab');

            $(parent).find('button.tablinks').removeClass('active');
            $(this).addClass('active');
            $(parent).find('.tab-main-content').removeClass('active');
            $(parent).find('#' + tab_id).addClass('active');
          }
        });

        $(document).on('click','.mri-tab-section .tabaccordion a',function(e){
          e.preventDefault();
          var tab_id = $(this).attr('data-href');
          var button = $(this);
          var is_active = $(this).parent('.tabaccordion').hasClass('active');
          $('.mri-tab-section .tabaccordion').removeClass('active');
          $('.mri-tab-section .tab-main-content, .mri-tab-section button.tablinks').removeClass('active');
           

          if( !is_active ){
            $(this).parent('.tabaccordion').addClass('active');
            $('#'+tab_id).addClass('active');
            $('.mri-tab-section button.tablinks[data-tab='+tab_id+']').addClass('active');
            
            $('body,html').animate({
                scrollTop: button.offset().top - 100
            }, 300);

          }

        });

        $(document).on('click','.close-lng-popup',function(e){
          e.preventDefault();
          $('.lity-close').click();
        });

        $(document).on('lity:open', function(event, instance) {
          var opener = instance.opener();
          $('body').toggleClass('lity-opened');
          if ( typeof opener.attr('data-litytype') !== 'undefined' ) {
            $('.lity').addClass( opener.attr('data-litytype') ).attr('data-extraclass',opener.attr('data-litytype'));
            if ( opener.attr('data-litytype') === 'lity-language-modal-cnt' ) {
              $('.mri-flipping-animate-numbers').removeClass('animated');
              $('html,body').animate({ scrollTop: 10 }, 0);
              $('html,body').animate({ scrollTop: 0 }, 0);
              $('.mri-lng-container .language-list a').matchHeight();
            }
          }
        });

        $(document).on('lity:close',function(event, instance) {
          $('body').toggleClass('lity-opened');
        });

        $(document).on('hover','.new-mega-menu-navigation .dropdown-submenu .submenu-tabs li:not(.active-tab)',function(e){
          e.preventDefault();
          var menu_id = $(this).attr('data-menuid');
          var parent = $(this).closest('.dropdown-submenu');
          parent.find('.submenu-tabs li').removeClass('active-tab');
          $(this).addClass('active-tab');
          parent.find('.submenu-tabcontent li').removeClass('active-tab');
          parent.find('.submenu-tabcontent li[data-menuid='+menu_id+']').addClass('active-tab');
          parent.find('.submenu-related li').removeClass('active-tab');
          parent.find('.submenu-related li[data-menuid='+menu_id+']').addClass('active-tab');
        });

        // Partners infinite scroll
        $(window).scroll(function() {
          if ( $('body').hasClass('page-template-partners-list') ) {
            if( $(window).scrollTop() + $(window).height()  >= $(document).find('footer.site-footer').offset().top ) {
              if ( ! $('body').hasClass('load-more-in-progress') ) {
                $(document).find('.post_filtering_more').click();
              }
            }
          }
        });

        $('.btn-scroll-to').click( function(e) {
          e.preventDefault();
          var target = $( $(this).attr('href') );
          var margin = $('#main-header').height();

          $('html,body').animate({
             scrollTop: ( target.offset().top - margin )
          });

        });

        function showHideAccordion(){
          var nav_tabs = $('.mri-tab-section button.tablinks');
          var nav_accordion = $('.mri-tab-section div.tabaccordion');
          if(window.innerWidth >= 768){
              nav_tabs.show();
              nav_accordion.remove();
              if( $('.mri-tab-section .tab-main-content.active').length <= 0) {
                $('.mri-tab-section .tab-main-content').eq(0).addClass('active');
              }      
              $('header#main-header').removeAttr('style');
              $('.site-content').removeAttr('style');    
              $('#mri-mobile-menu-container').removeAttr('style');   
          } else {
            // if ( $('body').hasClass('gdpr-infobar-visible') ) {
            //   $('header#main-header').css('top',$('#moove_gdpr_cookie_info_bar').height());
            //   $('.site-content').css('padding-top',$('#moove_gdpr_cookie_info_bar').height() + 70);
            //   $('#mri-mobile-menu-container').css('padding-top',$('#moove_gdpr_cookie_info_bar').height() + 70);
            // }
            // setTimeout(function(){
            //   if ( $('body').hasClass('gdpr-infobar-visible') ) {
            //     $('header#main-header').css('top',$('#moove_gdpr_cookie_info_bar').height());
            //     $('.site-content').css('padding-top',$('#moove_gdpr_cookie_info_bar').height() + 70);
            //     $('#mri-mobile-menu-container').css('padding-top',$('#moove_gdpr_cookie_info_bar').height() + 70);
            //   }
            // }, 1000);
            
            if(nav_accordion.length <= 0) {
              $('.mri-tab-section .tab-main-content').removeClass('active');
              nav_tabs.each(function(){
                var tab_id = $(this).attr('data-tab');
                var tab_title = $(this).text();
                $(this).hide();
                $('#'+tab_id).before('<div class="tabaccordion" ><a data-href="'+tab_id+'" >'+tab_title+'</a></div>');
              });
            }
          }
        }

        showHideAccordion();

        $( window ).resize(function() {
          showHideAccordion();
        });

        iFrameResize({ 
          log: false,
          autoResize: false,
          checkOrigin: false,
          heightCalculationMethod : 'max',
          onInit : function(iframe){
            Sage.common.matchHeights();
            $('.gated-content').hide().css('opacity', 1);
            $('.js-show-form.not-loaded').hide().removeClass('not-loaded');

            if ($(window).width() >= 768) {
              $('section.contact-boxes .box-mh').matchHeight( {byRow: false });
            }

          },
          resizedCallback : function() {
            if ($(window).width() >= 768) {
              $('section.contact-boxes .box-mh').matchHeight( {byRow: false });
            }
          }
        }, '.pardotform');

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
